import { render } from "./GD.vue?vue&type=template&id=ccf93380"
import script from "./GD.vue?vue&type=script&lang=js"
export * from "./GD.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__